export default __webpack_public_path__ + "static/media/01_ms.ddad52c7.png";